import { range, findIndex, map, filter, every, isNil } from 'lodash';

export default {
  currentRound: (state) => state.gameState.eventId,
  isCompactLayout: (state) => state.gameLayout === 'compact',
  isExpandedLayout: (state) => state.gameLayout === 'expanded',
  getNumberColor: (state) => (number) => {
    const colors = state.bingoColors;
    return colors[(number - 1) % colors.length];
  },
  bingoNumbers: (state, getters) => {
    const numbers = range(state.minBingoNumber, state.maxBingoNumber + 1);
    return map(numbers, (number) => {
      const color = getters.getNumberColor(number);
      return {
        hex: color,
        value: number,
        isSelected: findIndex(getters.selectedBingoNumbers, (n) => n.number === number) > -1,
      };
    });
  },
  specials: (state) => {
    const excludedSpecials = [0, 1, 2, 3, 4, 5, 9, 10];
    const { bets } = state.config;

    return filter(bets, (bet) => bet.value && !excludedSpecials.includes(bet.id));
  },
  firstBallColor: (state) => state.config.bets[5],
  roundId: (state) => state.roundId,
  regulatoryMessageText: (state) => state.config.ui.config.regulatoryMessage,
  isIsonis: (state) => state.isonisList.indexOf(state.config.taxAuthority) > -1,
  isBoostActive: (state) => state.config.ui.config?.boost?.enabled || false,
  isTerminalLayout: (state) => state.layout === 'terminal',
  isTerminalChannel: (state) => state.config.applicationName.toLowerCase() === 'terminal',
  systemBetsDisabled: (state) => {
    const { bets } = state.config;
    const systemBets = filter(bets, (bet) => bet.betType === 'System');
    return every(systemBets, ['value', false]);
  },
  combinationsBase: (state) => state.combinationsBase,
  ajsDisabled: (state) => state.config?.ui?.config?.ajsDisabled ?? false,
  isNextGen: (state) => state.config.platformName === 'NextGen',
  freeBetFeatureActive: (state) => state.config.ui.config.freeBetFeatureActive,
  customDomain: (state) => state.config.customDomain,
  isThirdPartyIntegration: (state) => state.appMode === 'thirdPartyIntegration',
  customProductName: (state) => state.config.ui?.config?.customProductName,
  // TODO: Remove true default when all apps adapted and ensured all clients with custom/translated product name are adapted through static config
  translateProductName: (state) => state.config.ui?.config?.translateProductName ?? true,
  gameTitle: (state, getters) => {
    if (!isNil(getters.customProductName)) {
      return getters.customProductName;
    }
    return getters.translateProductName
      ? getters.translations?.[state.usePackageTranslations ? 'product_name' : 'gameTitle']
      : 'Lucky Six';
  },
  isFrontIntegration: (state) => state.frontIntegration.enabled,
  staticConfig: (state) => state.config?.ui?.config || {},
  isBettingDisabled: (state) => state.isBettingDisabled,
  allColorsBet: (state) => state.config.ui.config.allColorsBet,
  disableAllColorBetButton: (state) => state.disableAllColorBetButton,
};
